export default "__VITE_ASSET__C2iqD$Yp__"